
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Icon,
  Input,
  Modal,
  Drawer,
  notification,
  Row,
  Select,
  Table,
  Tooltip
} from 'antd'
import _ from 'lodash'
import moment from 'moment'
import React, { PureComponent, useState } from 'react'

import { connect } from 'react-redux'
import GetEachFormFields from '../../../components/_utils/appFormUtils'
import { getPushPathWrapper, getUrlParams } from '../../../routes'

import { Editor } from 'react-draft-wysiwyg'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import {
  ArticleTypeList,
  chooseEmailModalFxn,
  Countries,
  CustomCkEditor,
  DesignationList,
  InputBox,
  mentionsFeeds,
  NotificationBox,
  ProcessList
} from '../../../components/_utils/appUtils'
import { CountriesList, JournalList } from '../../journals/actions'
import { singleOnlineSubmission } from '../../onlineSubmission/actions'
import { addMember, checkMemberEmails } from '../../members/actions'
import { addCourierFxn, addSubscriptionActivityFxn } from '../action'
import Request from '../../../request'

@Form.create()
class AddCourierDrawer extends PureComponent {
  state = {
    journal: '',
    mode: '',
    copies: '',
    date: '',
    volumeName: '',
    issues:[],

  }

  constructor(props) {
    super(props)
    console.log(props, "checcccccccccccccccccc")
  }



  resetFormData = () => {
    const { dispatch, form } = this.props
    form.setFieldsValue({
      journal: '',
      mode: '',
      copies: '',
      date: '',
      volumeName: '',
      issues: [],
    })
  }

  componentDidMount() {
    this.loadJournalList()
    this.getJournalList()
    let data = getUrlParams('article.onlineSubmission', this.props.pathname)
    if (!!data) {
      let { id } = data
      this.setFormValuesFxn(id)
    }
  }
  getJournalList = async () => {
    let { data } = await Request.journalName()
    let journalList = []
    _.each(data, item => {
      journalList.push({
        _id: item._id,
        value: item.slugJournal,
        display: item.name
      })
    })
    console.log(journalList)

    this.setState({ journalNameList: journalList })
  }

  loadJournalList = async () => {
    const { dispatch, form } = this.props
    let { data } = await JournalList()
    this.setState({ journalListArr: data })
    form.setFieldsValue({ enterDate: moment() })
  }


  chooseDocument = e => {
    let { name, files } = e.target
    if (files && files.length) {
      this.setState({ [name]: files[0] })
    }
  }
 getJournalsVolumeData = async (id) => {
    let { data } = await Request.getJournalsVolumeList({ journalId: id })
    let volumeList = []
    _.each(data, (item) => {
      volumeList.push({
        _id: item._id,
        name: item.volumeName
      })
    })
   this.setState({ journalVolumeList: volumeList })
  }
   getJournalsIssueData = async (volumeName) => {
    let volume = _.find(this.state.journalVolumeList, (item) => {
      return item.name.toLowerCase() == volumeName.toLowerCase()
    })
    if (volume && volume._id) {

      let { data } = await Request.getJournalIssue()
      let issueList = []
      _.each(data, (item) => {
        issueList.push({
          _id: item._id,
          name: item.issueName
        })
      })
      this.setState({ journalIssueList: issueList })
    }
  }

  handleSubmit = e => {
    const { dispatch, form } = this.props
    let urlObj = getUrlParams('singleGeneralSubscription', window.location.pathname)
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        valData.generalSubscriptionId =urlObj.id
        if(this.props.missingIssues){
          valData.missingIssues = this.props.missingIssues
        }
          let { success, message } = await dispatch(addCourierFxn(valData))
        if (success) {
          notification.success({
            message: message
          })
          this.props.reloadData()
          this.resetFormData()
          this.props.onClose()

        }
      }
    })

  }


  render() {
    const {
      form: { getFieldDecorator, getFieldValue, setFieldsValue },
      loading
    } = this.props
    const { edit, journalListArr, lastArticleNo, visibleAddAuthor } = this.state

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 24 },
        md: { span: 24 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
        md: { span: 24 }
      }
    }

    const inputSchma = {
      fields: [

        {
          label: 'Journal Name',
          key: 'journal',
          placeholder: 'Select',
          type: 'select',
          required: true,
          options: this.state.journalNameList,
          onChange: (e) => {
            setFieldsValue({ journal: e, })
            this.getJournalsVolumeData(e)
          }
        },

        // {
        //   label: 'Tracking No',
        //   key: 'trackingNo',
        //   required: true,
        //   placeholder: 'Tracking No',
        // },
        {
          label: 'Date',
          key: 'date',
          required: true,
          placeholder: 'Date',
          type: 'date'
        },
        {
          label: 'Mode',
          key: 'mode',
          required: true,
          placeholder: 'Mode',
        },
        {
          label: 'Copies',
          key: 'copies',
          required: true,
          placeholder: 'Copies',
          type:'number',

        },
        {
          label: 'Volume',
          key: 'volumeName',
          placeholder: 'Select',
          type: 'select',
          required: true,
          keyAccessor: x => x.name,
          valueAccessor: x => x.name,
          options: this.state.journalVolumeList,
          onChange: async (selectedVolume) => {
            setFieldsValue({ volumeName: selectedVolume,  });
            await this.getJournalsIssueData(selectedVolume);
          }
        },
        {
          label: 'Issue',
          key: 'issues',
          placeholder: 'Select',
          type: 'select',
          required: true,
          mode: 'multiple',
          keyAccessor: x => x.name,
          valueAccessor: x => x.name,
          options: this.state.journalIssueList,
          onChange: (e) => {
            setFieldsValue({ issues: e })
          }
        },

      ]

    }



    return (
      <Drawer
        title={'Add Courier Details'}
        width={'45%'}
        visible={this.props.visible}
        maskClosable={true}
        placement='right'
        onClose={this.props.onClose}>
        <Card bordered={true}>
          <Form
            onSubmit={this.handleSubmit}
            hideRequiredMark
            className={'inputForm'}>
            <Row gutter={16}>
              <Col span={24}>
                <Card  bordered={true}>
                  <Row gutter={16}>
                    {inputSchma.fields.map((item, key) => {
                      return (
                        !item.hidden && (
                          <Col
                            span={item.span ? item.span : 12}
                            md={item.span ? item.span : 12}
                            sm={12}
                            xs={24}
                            key={key}>
                            {item.customField ? (
                              item.customField
                            ) : (
                              <GetEachFormFields
                                item={item}
                                getFieldDecorator={getFieldDecorator}
                                formItemLayout={formItemLayout}
                              />
                            )}
                          </Col>
                        )
                      )
                    })}
                  </Row>
                </Card>
              </Col>

            </Row>

            <Form.Item style={{ marginTop: 32 }}>
              <Button type="primary" htmlType="submit">
                SUBMIT
              </Button>
            </Form.Item>
          </Form>


        </Card>
      </Drawer>
    )
  }
}

const mapStateToProps = ({ global, router }) => ({
  loading: global.buttonLoading,
  categories: global.categories,
  search: router.location.search,
  pathname: router.location.pathname

})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}

export default connect(mapStateToProps,
  mapDispatchToProps
)(AddCourierDrawer)
